import { render } from "./Client.vue?vue&type=template&id=22fec3f7&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=22fec3f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22fec3f7"

export default script